/**
 * @deprecated Use direct UPM hooks for plant metadata and time handling. Keep plant config usage
 * limited to feature availability and loading flows until the remaining plant-config consumers are
 * migrated.
 */
import {usePlantConfigQuery} from '../hooks/api'

export const usePlantConfig = () => {
  const {data: plantConfig} = usePlantConfigQuery()
  if (!plantConfig) throw new Error('Plant config data is not available')
  return plantConfig
}
